import classNames from 'classnames';
import React from 'react';

import { Image } from 'src/components/common/Image';
import AccentProgress from 'src/components/common/accent-progress/accent-progress';
import CircleButton from 'src/components/common/circle-button/circle-button';
import { QuizSection } from 'src/constants/quiz';

import ChevronLeft from '../../../../assets/icons/chevron-left.svg';
import Star from '../../../../assets/icons/star.svg';
import TrackNext from '../../../../assets/icons/track-next.svg';
import styles from './onboarding-header.module.scss';

type Props = {
  hideGoPrevious: boolean;
  goToPreviousStep: () => void;
  step: {
    section: string;
  };
  canSkipQuiz: boolean;
  handleQuizSkipClick: () => void;
  calculateProgress: ({ quizSection }: { quizSection: QuizSection }) => number;
  country: string | undefined;
};
export const OnboardingHeader = ({
  hideGoPrevious,
  goToPreviousStep,
  step,
  canSkipQuiz,
  handleQuizSkipClick,
  calculateProgress,
  country = 'US',
}: Props) => (
  <>
    <div className={styles.topRatedBanner}>
      <Image src="header-logo.webp" width={24} height={24} alt="" />
      <span>TOP RATED APP IN {country}</span>
      <div className={styles.rating}>
        <Star width={13} height={13} /> 4.8
      </div>
    </div>
    <div className={styles.header}>
      <CircleButton
        className={classNames(
          styles.headerButton,
          hideGoPrevious && styles.hideGoPrevious,
        )}
        onClick={goToPreviousStep}>
        <ChevronLeft className={styles.headerButtonIcon} />
      </CircleButton>
      <p className={styles.quizSectionTitle}>{step.section}</p>
      {canSkipQuiz && (
        <CircleButton
          className={styles.headerButton}
          onClick={handleQuizSkipClick}>
          <TrackNext className={styles.headerButtonIcon} />
        </CircleButton>
      )}
      <div className={styles.progressContainer}>
        <AccentProgress
          className={classNames(styles.progress)}
          progress={calculateProgress({
            quizSection: 'Introduction',
          })}
        />
        <AccentProgress
          className={classNames(styles.progress)}
          progress={calculateProgress({
            quizSection: 'Life purpose',
          })}
        />
        <AccentProgress
          className={classNames(styles.progress)}
          progress={calculateProgress({
            quizSection: 'Mood & Emotions',
          })}
        />
        <AccentProgress
          className={classNames(styles.progress)}
          progress={calculateProgress({
            quizSection: 'Personalization',
          })}
        />
        <AccentProgress
          className={classNames(styles.progress)}
          progress={calculateProgress({
            quizSection: 'Relationship status',
          })}
        />
      </div>
    </div>
  </>
);
